<template>
    <div class="container">
        <div v-if="patrimonio">

            <div class="simulator-box card-panel">

                <h2 class="simulator-title" :class="{loaded: cliente, 'with-animation' : carregando}">Patrimônio</h2>

                <input-simulador input-type="price" label="Imóveis" @input="salvar" v-model="patrimonio.imoveis" />

                <input-simulador input-type="price" label="Veículos" @input="salvar" v-model="patrimonio.veiculos" />

                <input-simulador input-type="price" label="Investimentos" @input="salvar" v-model="patrimonio.investimentos" />
                <input-simulador input-type="price" label="Máquinas / Equipamentos" @input="salvar" v-model="patrimonio.maquinas_equipamentos" />

                <input-simulador
                    input-type="price"
                    label="Saldos Bancários"
                    description="Reservas, Poupança"
                    @input="salvar"
                    v-model="patrimonio.saldos_bancarios" />


                <input-simulador
                    input-type="price"
                    label="Participações Societárias"
                    @input="salvar"
                    v-model="patrimonio.participacoes_societarias" />

                <input-simulador input-type="price"
                    label="Outros"

                    @input="salvar" v-model="patrimonio.outros" />

                <total-simulador label="TOTAL" :value="soma" />

            </div>

            <div class="simulator-box card-panel">

                <div class="mb-3 flex-row">
                    <div class="col-xs-12 col-sm-6">
                        <a href class="text-primary" @click.prevent="() => modal_ano = true">Selecione o Estado (opcional)</a>
                    </div>
                    <div class="col-xs-12 col-sm-6 right-align" v-if="aliquota_patrimonial_grupo">
                        <h4 class="simulator-title">{{ aliquota_patrimonial_grupo.nome }} - {{  patrimonio.ano }}</h4>
                    </div>
                </div>
                <modal title="Configurar o Estado" :is-active.sync="modal_ano">

                    <div class="flex-row">
                        <div class="col-xs-12 col-sm-6">
                            <label>Selecione o Estado</label>
                            <div class="title-select" >
                                <select v-model="patrimonio.aliquota_patrimonial_grupo_id" @change="() => patrimonio.ano = null">
                                    <option :value="null">(selecione)</option>
                                    <option :value="item.aliquota_patrimonial_grupo_id" v-for="item in aliquotas_patrimoniais_grupos" :key="`apg-${item.aliquota_patrimonial_grupo_id}`">{{ item.nome }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-6" v-if="patrimonio.aliquota_patrimonial_grupo_id">
                            <label>Selecione o ano</label>
                            <div class="title-select">
                                <select v-model="patrimonio.ano" @change="configurarAliquotaPatrimonial">
                                    <option  :value="null" >(selecione)</option>
                                    <option :value="ano" v-for="ano in aliquota_patrimonial_grupo.anos" :key="`ano-${ano}`">{{ ano }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="right-align">
                        <button @click.prevent="fecharModal()" class='btn btn-default'>
                            Salvar
                        </button>
                    </div>
                </modal>

                <input-simulador label="Custos Judiciais" @input="salvarLimpandoAliquotaPadrao" v-model="patrimonio.custos_judiciais" input-type="percent">
                    <svg-percentage class="svg-icon" slot="icon"/>
                </input-simulador>

                <input-simulador label="Impostos ITCD" input-type="percent" @input="salvarLimpandoAliquotaPadrao" v-model="patrimonio.imposto_itcd">
                    <svg-percentage class="svg-icon" slot="icon"/>
                </input-simulador>

                <input-simulador label="Advogado" @input="salvarLimpandoAliquotaPadrao" v-model="patrimonio.advogados" input-type="percent">
                    <svg-percentage class="svg-icon" slot="icon"/>
                </input-simulador>

                <total-simulador :label="`${porcentagem}%  DO PATRIMÔNIO`" :value="somaPorcentagem" />

            </div>

            <div class="simulator-box card-panel">
                <total-simulador label="PATRIMÔNIO LÍQUIDO" :value="soma - somaPorcentagem" />
            </div>

            <footer-simulador :action="concluir" :loading.sync="carregando" />


        </div>
    </div>
</template>


<script>

import {put, get, api} from "@/helpers/api";
import "@/../static/assets/css/custom/flex.css";
import debounce from "lodash/debounce";

import InputSimulador from '@/components/common/InputSimulador.vue';
import TotalSimulador from '@/components/common/TotalSimulador.vue';
import SvgPercentage from '@/components/common/svg/SvgPercentage.vue';
import FooterSimulador from "@/components/common/FooterSimulador.vue";

import Modal from "@/components/common/Modal/Base.vue";

export default {

    components: {InputSimulador, SvgPercentage, TotalSimulador, FooterSimulador, Modal},

    name: 'patrimonio',

    async created() {

        const {id} = this.$route.params;

        const {data: {result: {data: cliente}}} = await api.get(`cliente/${id}`);

        const {data: {result: {data: grupos}}} = await api.get('aliquota-patrimonial-grupo');

        const {data: config} = await api.get('configuracoes');


        this.aliquotas_patrimoniais_grupos = grupos

        const patrimonio = {
            imoveis: 0,
            veiculos: 0,
            investimentos: 0,
            maquinas_equipamentos: 0,
            saldos_bancarios: 0,
            participacoes_societarias: 0,
            outros: 0,
            ano: null,
            ...cliente.patrimonio,
            cliente_id: cliente.cliente_id
        };


        if (config.aliquota_patrimonial_ano && !cliente.patrimonio) {

            patrimonio.aliquota_patrimonial_grupo_id = config.aliquota_patrimonial_ano[0]
            
            patrimonio.ano = config.aliquota_patrimonial_ano[1]
        }



        this.patrimonio = patrimonio;

        await this.configurarAliquotaPatrimonial()

        this.cliente = cliente;

    },


    computed: {

        porcentagem()
        {

            let soma_porcentagem = 0;

            ['custos_judiciais', 'imposto_itcd', 'advogados'].forEach(key => {

                let num = parseFloat(this.patrimonio[key]);

                soma_porcentagem += isNaN(num) ? 0 : num;

            });


            return soma_porcentagem;
        },

        somaPorcentagem() {
            return (this.soma * this.porcentagem * 0.01);
        },
        soma() {

            let keys = [
                "imoveis",
                "veiculos",
                "investimentos",
                "maquinas_equipamentos",
                "saldos_bancarios",
                "outros",
                'participacoes_societarias'
            ];

            let total = 0;

            keys.forEach(key => {

                let num =  parseFloat(this.patrimonio[key]);

                total += isNaN(num) ? 0 : num;
            })

            return total;
        },

        aliquota_patrimonial_grupo()
        {
            const grupo = this.aliquotas_patrimoniais_grupos.find(item => {
                return item.aliquota_patrimonial_grupo_id === this.patrimonio.aliquota_patrimonial_grupo_id
            })

            return grupo;
        }
    },

    data() {
        return {
            aliquotas_patrimoniais_grupos: [],
            aliquotas_patrimoniais: [],
            cliente: null,
            patrimonio: null,
            carregando: false,

            modal_ano: false,
        };
    },

    methods: {

        concluir() {

            if (! this.patrimonio.patrimonio_id && !this.soma) return;

            this.salvar();
        },

        // Melhorar isso depois
        validar() {

            return this.patrimonio.patrimonio_id || [
                "imoveis",
                "veiculos",
                "investimentos",
                "maquinas_equipamentos",
                "saldos_bancarios",
                "outros",
                "participacoes_societarias",
            ].some(key => {
                return this.patrimonio[key] !== 0
            })

        },

        salvarSemValidar: debounce(async function() {

            this.carregando = true;

            try{
                await api.put('patrimonio', this.patrimonio);
            } finally {
                setTimeout(() => this.carregando = false, 2000);
            }

        }, 250),

        async salvar() {

            if (! this.validar()) return;

            await this.salvarSemValidar()
        },

        async salvarLimpandoAliquotaPadrao() {

            this.patrimonio.aliquota_patrimonial_grupo_id = null;
            this.patrimonio.ano = null;
            await this.salvar();
        },

        fecharModal() {
            this.modal_ano = false;
            this.salvarSemValidar()
        },


        async configurarAliquotaPatrimonial() {


            if (! this.patrimonio.aliquota_patrimonial_grupo_id) return;

            const params = {
                aliquota_patrimonial_grupo_id: this.patrimonio.aliquota_patrimonial_grupo_id,
                ano: this.patrimonio.ano
            };

            const {data: {result: {data: aliquotas_patrimoniais}}} = await api.get('aliquota-patrimonial', {params});

            this.aliquotas_patrimoniais = aliquotas_patrimoniais;

            this.patrimonio = {...this.patrimonio, custos_judiciais: null, advogados: null, imposto_itcd: null};

            aliquotas_patrimoniais.forEach(item => {

                if (item.tipo === 'J') {
                    this.$set(this.patrimonio, 'custos_judiciais', item.porcentagem);
                } else if (item.tipo == 'I') {
                    this.$set(this.patrimonio, 'imposto_itcd', item.porcentagem);
                } else if (item.tipo === 'A') {
                    this.$set(this.patrimonio, 'advogados', item.porcentagem);
                }
            })

        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/clientes/Patrimonio.vue